export default function isSP() {
  return window.matchMedia('(max-width:767px)').matches
}
